import { BehaviorState } from '../slices/behaviorSlice'
import { RootState } from '../store'

export const selectBehavior = (state: RootState): BehaviorState => state.behavior
export const selectSelectedInventoryId = (state: RootState) => state.behavior?.inventory_id ?? 0
